import React from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import BannerTwo from "../components/BannerTwo";
import PromotionalTwo from "../components/PromotionalTwo";
import OurStory from "../components/OurStory";
import RecentlyViewedOne from "../components/RecentlyViewedOne";
import ShippingOne from "../components/ShippingOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import "./HomePageTwo.css";
import { useLocation } from "../context/LocationContext";

const HomePageTwo = () => {
  const { priceRegion } = useLocation();


  return (

    <div className="home-page-two">
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderOne */}
      <HeaderOne category={true} />

      {/* BannerTwo */}
      <BannerTwo />

      {/* PromotionalTwo */}
      <PromotionalTwo />

      {/* OurStory */}
      <OurStory />

      {/* RecentlyViewedOne */}
      <RecentlyViewedOne key={`recently-${priceRegion}`} />

      {/* ShippingOne */}
      <ShippingOne />

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />


    </div>
  );
};

export default HomePageTwo;
